export default __webpack_public_path__ + "static/media/boosty.79020bab.svg";